/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3RyaWFnZS1jb21wb25lbnRzL3RyaWFnZS1xdWVzdGlvbnMvdHJpYWdlLXF1ZXN0aW9uLWJvb2tpbmctd2luZG93cy90cmlhZ2UtcXVlc3Rpb24tYm9va2luZy13aW5kb3dzLmNvbXBvbmVudC5jc3MifQ== */"];
export { styles as styles };
